import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const SupplierCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const {  recall, setRecall } = app
  const { create, update, } = app.suppliers
  const scope = model?"Guardar":"Crear"
  const submit = d=>  model?update(d):create(d)
  const title = scope+" Proveedor"
  
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={submit}
        obj={{name:'', }}
        types={{name:'text', }}
        labels={{name:'nombre', }}
        changed={model?model:{}}
      />
      <Button onClick={() => {setRecall(true);close()}}>{scope}</Button>
    </Dialog>
  )
}
export default SupplierCreate